module.exports = __webpack_public_path__ + "img/INSUFLÁVEIS - ROSA.aff7fc6b.svg";